import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../../utils/apiConfig';
import ProductDetailsFields from './ProductDetailsFields';
import ProductImagesTab from './ProductImagesTab';
import ProductFeaturesTab from './ProductFeaturesTab';
import ProductSpecificationsTab from './ProductSpecificationsTab';
import ProductPromoBannerTab from './ProductPromoBannerTab';
import ProductDetailTabsTab from './ProductDetailTabsTab';
import { mapProductFromApi } from './utils/mapProduct';

function ViewProduct({ ProductData, tabTypes = [] }) {
  const [formData, setFormData] = useState(ProductData || {});
  const [activeTab, setActiveTab] = useState('details');

  useEffect(() => {
    const load = async () => {
      if (ProductData?.ProductId) {
        try {
          const response = await axios.get(`${getApiBaseUrl()}/ec-product/getById`, {
            params: { ProductId: ProductData.ProductId },
          });
          if (response.data?.data) {
            setFormData(mapProductFromApi(response.data.data, tabTypes));
          }
        } catch (err) {
          console.error(err);
          setFormData(ProductData);
        }
      } else {
        setFormData(ProductData || {});
      }
    };
    load();
  }, [ProductData, tabTypes]);

  return (
    <div className="card-body px-0">
      <nav className="nav nav-style-6 nav-pills mb-3 nav-justified d-sm-flex d-block" role="tablist">
        <button type="button" className={`nav-link ${activeTab === 'details' ? 'active' : ''}`} onClick={() => setActiveTab('details')}>Product Details</button>
        <button type="button" className={`nav-link ${activeTab === 'images' ? 'active' : ''}`} onClick={() => setActiveTab('images')}>Upload Images</button>
        <button type="button" className={`nav-link ${activeTab === 'features' ? 'active' : ''}`} onClick={() => setActiveTab('features')}>Product Features</button>
        <button type="button" className={`nav-link ${activeTab === 'specs' ? 'active' : ''}`} onClick={() => setActiveTab('specs')}>Product Specifications</button>
        <button type="button" className={`nav-link ${activeTab === 'promo' ? 'active' : ''}`} onClick={() => setActiveTab('promo')}>Promo Banner</button>
        <button type="button" className={`nav-link ${activeTab === 'detail-tabs' ? 'active' : ''}`} onClick={() => setActiveTab('detail-tabs')}>Detail Page Tabs</button>
      </nav>
      <div className="tab-content">
        {activeTab === 'details' && <ProductDetailsFields formData={formData} readOnly />}
        {activeTab === 'images' && (
          <ProductImagesTab
            productId={formData.ProductId}
            images={formData.Images}
            isPromoBanner={!!formData.IsPromoBanner}
            readOnly
          />
        )}
        {activeTab === 'features' && <ProductFeaturesTab productId={formData.ProductId} features={formData.Features} readOnly />}
        {activeTab === 'specs' && <ProductSpecificationsTab productId={formData.ProductId} specifications={formData.Specifications} readOnly />}
        {activeTab === 'promo' && <ProductPromoBannerTab formData={formData} readOnly />}
        {activeTab === 'detail-tabs' && (
          <ProductDetailTabsTab detailTabs={formData.DetailTabs} tabTypes={tabTypes} readOnly />
        )}
      </div>
    </div>
  );
}

export default ViewProduct;
